import { useApp, useBehavior, useTriggerAction } from '@libs/core';
import React, { ChangeEvent, useCallback } from 'react';
import { TInputData, TWidgetProps } from '@libs/types';
import { TOTPOption } from '../../types/options';
import { useConsumerInput } from '../../hooks/useInputs';
import { OtpInputView } from './OtpInputView';

export const OtpInputWidget = ({ widget }: TWidgetProps<TInputData, TOTPOption>) => {
    const { margin, onFocus = false, codeLength = 6, allowAllSymbols = false, dividerPosition = 0, isHideSymbols = false } = widget.options ?? ({} as TOTPOption);
    const data = widget.data ?? {};
    const { isHidden, isDisabled } = useBehavior(widget);
    const { triggerActionsByType } = useTriggerAction(widget);
    const { setModal } = useApp();
    const { value, isFocused, isError, errorMessage, handleChange, handleFocus, handleBlur, updateInputValue, setError } = useConsumerInput(
        { ...widget, data: { ...widget.data, submitLength: codeLength } },
        {
            isHidden,
            isDisabled,
            triggerActionsByType,
            setModal,
        },
    );

    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    const handleOtpChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const raw = e.target.value ?? '';
            const cleaned = (allowAllSymbols ? raw : raw.replace(/\D/g, '')).slice(0, codeLength);
            handleChange?.({ ...e, target: { ...e.target, value: cleaned } } as ChangeEvent<HTMLInputElement>);
        },
        [allowAllSymbols, codeLength, handleChange],
    );

    const handleClearOnError = useCallback(() => {
        updateInputValue('');
        setError(false);
    }, [updateInputValue, setError]);

    return (
        <OtpInputView
            widget={widget}
            uid={widget.uid}
            value={value}
            isFocused={isFocused}
            codeLength={codeLength}
            dividerPosition={dividerPosition}
            isHideSymbols={isHideSymbols}
            allowAllSymbols={allowAllSymbols}
            autoFocus={onFocus}
            tabIndex={data.tabIndex}
            isError={isError}
            isDisabled={isDisabled}
            isHide={isHidden}
            errorMessage={errorMessage}
            margin={margin}
            parentStyleNames={parentStyleNames}
            onChange={handleOtpChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onClearOnError={handleClearOnError}
        />
    );
};
